import React, { useEffect, useState } from 'react';
import { Button, DialogBox, KgSlider } from '@/_component/Common';
import { fetchListingDetails, registerLead } from '@/apis';
import { BANK_SERVICE_CATEGORY_ID, BESTDEAL_USER_IMG, BLACK_BESTDEAL_USER_IMG, BLACK_CATLOG_USER_IMG, BLACK_OFFER_USER_IMG, BLACK_PRODUCT_USER_IMG, CATLOG_USER_IMG, GREATDEALS, MACHINERY_CATEGORY_ID, MYPOSTINGS, NO_IMAGE, OFFER_USER_IMG, OFFERRESULTS, PRODUCT_USER_IMG, PROPERTY_CATEGORY_ID, QUERY_PARAM_ORIGIN_LISTING_ID_NAME, SEARCH_LINK } from '@/_constant';
import { comparePhoneNumber, constructValidationError, hashEncode, renderError, timeout, validateSchema } from '@/utility';
import * as Yup from "yup";
import { useAuthContext, useLanguageContext, useLoginToggle } from '@/hooks';
import { Link, useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { SharePopup } from '@/_component/shared';
import Swal from 'sweetalert2';
import { userProfile } from '@/apis/search-service';
import MainAdsLayout from '@/_component/MainAdsLayout';

const UserProfileDetail = () => {
    
    const location = useLocation();
    const userAccessId = location.state?.userAccessId;
    const { language } = useLanguageContext();
    const navigate = useNavigate();
    const { isAuth, user } = useAuthContext();
    const handleLoginToggle = useLoginToggle();
    const [searchParams] = useSearchParams();
    const { listingId } = useParams();
    const [userData, setUserData] = useState([]);
    const [item, setItem] = useState({});
    const [selectedMeta, setSelectMeta] = useState(null);
    const [toggleLoanDetailsPopup, setToggleLoanDetailsPopup] = useState(false);
    const [showSharePopup, setShowSharePopup] = useState(false);
    const [shareContent, setShareContent] = useState("");
    const [translatedDesc, setTranslateDesc] = useState("");

    const showLoanInterestedBtn = (item.zeroLevelCategoryId === BANK_SERVICE_CATEGORY_ID && !comparePhoneNumber(user.phone_number, item.creatorUserId));
    const showNeedLoanOption = (item.zeroLevelCategoryId === PROPERTY_CATEGORY_ID || item.zeroLevelCategoryId === MACHINERY_CATEGORY_ID);
    const [errors, setErrors] = useState(null);

    const handleLoanInterestedPopup = () => {
        setToggleLoanDetailsPopup(true);
    }

    const handleSharePopupClose = () => {
        setShowSharePopup(false);
        setShareContent("");
    }

    const handleShare = () => {
        const shareContent = "\u{1F642} Check this out: " + window.location.href
        setShareContent(shareContent);
        setShowSharePopup(true);
    }
    const getViewProfileDetails = async () => {


        const res = await userProfile(userAccessId);
        setUserData(res.data.response);
        console.log(res.data.response.data, 'setUserData', res);
        console.log(userData,'userData');

    };


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setLoanInterestedFormData((prevState) => {
            return {
                ...prevState,
                [name]: value
            };
        });
    }

    const validateLoanInterestedDetails = () => {
        try {
            return validateSchema(loanInterestedValidations, loanInterestedFormData);
        } catch (err) {
            const errors = constructValidationError(err);
            setErrors(errors);
            timeout(() => setErrors(null), 5000);
        }
    }


    const handleNeedLoanApplyNow = () => {
        const cateogryMapping = {
            1: 352, //Machinary loan
            2: 342 //poultry farm
        };
        const listingId = item.id;
        const cid = cateogryMapping[item.zeroLevelCategoryId];
        navigate(`${SEARCH_LINK}?cid=${hashEncode(cid)}&${QUERY_PARAM_ORIGIN_LISTING_ID_NAME}=${listingId}`);
    }

    useEffect(() => {
        getViewProfileDetails()
    }, [])

    const currentPrice = item?.metadata?.find(
        (item) => item?.listKey?.name === "OZ_CurrentPrice"
    )?.listValue;

    const additionalPlanStartDate = item?.metadata?.find(
        (data) => data.listKey.defaultDisplay === "End Date"
    )?.listValue;
    const additionalPlanEndDate = item?.metadata?.find(
        (data) => data.listKey.defaultDisplay === "Start Date"
    )?.listValue;

    const dashboardItems = [
                {
                  label: "Catalogs",
                  img: CATLOG_USER_IMG,
                  black_img: BLACK_CATLOG_USER_IMG,
                  bg: "bg-warning-subtle",
                  path: userData?.brochureUrl ?? "",
                  count: userData?.totalBrochures,
                },
                {
                  label: "Products",
                  img: PRODUCT_USER_IMG,
                  black_img: BLACK_PRODUCT_USER_IMG,
                  style: { backgroundColor: "#fff2eb" },
                  path: MYPOSTINGS,
                  count: userData?.totalListings,
                },
                {
                  label: "Offers",
                  img: OFFER_USER_IMG,
                  black_img: BLACK_OFFER_USER_IMG,
                  style: { backgroundColor: "#fdf0ff" },
                  path: OFFERRESULTS,
                  count: userData?.totalOffers,
                },
                {
                  label: "Best Deals",
                  img: BESTDEAL_USER_IMG,
                  black_img: BLACK_BESTDEAL_USER_IMG,
                  bg: "bg-info-subtle",
                  path: GREATDEALS,
                  count: userData?.totalBestDeals,
                },
              ];
    return (
        <MainAdsLayout>
            <div className="row harvester_about">
                <div className="col-md-8">
                    <div className="harvester_contant">
                        <section className="tab-content slickContainer">
                            <img src={userData?.profileThumbnailUrl || NO_IMAGE} className="img-fluid rounded" style={{ maxHeight: "27rem", width: "100%", objectFit: "contain" }} alt="Image" />
                        </section>
                        <div className="row shadow-sm py-2 kg-bg-light kg-dark-gray mt-2 rounded-2 mb-2">

                            {dashboardItems.map((item, i) => {
                                        const isZero = !item.count || item.count === 0;

                                const isActive = item.count > 0;

                                return (
                                    <div className="col-3" key={i}>
                                       <Link
                                            to={item.path}
                                            state={
                                                item.isBestDeals && userData?.categoryId
                                                ? JSON.stringify({
                                                    categoryId: userData.categoryId,
                                                    category: userData.categoryDisplayName?.toLowerCase()
                                                    })
                                                : undefined
                                            }
                                    >
                                            <div className="text-center">

                                                <div
                                                    className={`mx-auto d-inline-flex align-items-center justify-content-center circle text-center align-middle ${isActive ? "kg-white bg-warning-subtle" : "kg-light bg-light"}`}>
                                                    <img src={isZero ? item.black_img : item.img} alt={item.label} />
                                                </div>

                                                <div className={`fw-bold mt-2 ${isActive ? "" : "text-muted"}`}>
                                                    {item.label}
                                                </div>

                                            </div>
                                        </Link>
                                    </div>
                                );
                            })}

                        </div>
                        <div className="row card shadow-sm">
                            <div className="card-body">
                                <h4 className="card-title fw-bold mb-3">{language("label.about_us")}</h4>
                                <p>{userData?.about} </p>
                                {selectedMeta
                                    ?.filter((item) => item.key !== 'title' && item.key !== 'subtitle')
                                    ?.map((object, i) => (
                                        <div className="row mb-3" key={i}>
                                            <div className="col-md-3">
                                                {object.key}
                                            </div>
                                            <div className="col-md-7">
                                                {Array.isArray(object.value) ? (
                                                    <ul className="list-unstyled mb-0">
                                                        {object.value.map((v, idx) => (
                                                            <li key={idx}>
                                                                {v.defaultDisplay} – {v.charges}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                ) : (
                                                    translatedDesc || object?.value
                                                )}
                                            </div>

                                            {(object.key.toLowerCase() === 'description' && object.value) && <div className="col-md-2">
                                                <Button primary rounded small onClick={() => setTranslateDesc(translateWithGoogle(object?.value, defaultLang))}>{language("label.translate")}
                                                    <i className="bi bi-translate"></i>
                                                </Button>
                                            </div>}
                                        </div>
                                    ))}


                                <div className="d-flex justify-content-end">
                                    {showLoanInterestedBtn && <Button primary solid rounded onClick={handleLoanInterestedPopup}>I am Interested</Button>}
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
                <div className="col-md-4">
                    <div className="card mt-3">
                        <div className="card-body p-3">
                            <h3 className="fw-bold mb-2">
                                Dealer Detail
                            </h3>
                            {isAuth && <div className="d-flex flex-column gap-2 mb-2">
                                <div
                                    className="flex-grow-1"
                                >
                                    {/* Name */}
                                    <div className="fw-semibold fs-5 lh-md">
                                        {userData?.userName}
                                    </div>

                                    {/* Dealer line */}
                                    <div className="text-muted small">
                                        Dealer - {userData?.categoryDisplayName}
                                    </div>

                                    {/* Rating + Experience */}
                                    <div className="d-flex gap-2 flex-wrap mt-1">

                                        {/* Rating */}
                                        <span className="badge bg-success rounded-pill px-2">
                                            ★ {userData?.rating || "4.5"}
                                        </span>

                                        {/* Years */}
                                        <span className="badge bg-primary-subtle text-primary rounded-pill px-2">
                                            🏅 {userData?.years || "10+ years in business"}
                                        </span>

                                    </div>
                                </div>
                                <div>
                                    <span className="me-2">{language("label.phone")}:</span>
                                    <span>{
                                        userData?.phoneNumber
                                    }</span>
                                </div>
                                <div>
                                    <span className="me-3">{language("label.email")}:</span>
                                    <span>{userData?.email}</span>
                                </div>
                            </div>}
                            {!isAuth && <div className='card-body text-center'><Button primary solid rounded onClick={() => handleLoginToggle(true)}>View Dealer Details</Button></div>}
                        </div>
                        <div className="card-footer d-flex py-3">
                            <div><i className="bi bi-geo-alt-fill me-2"></i></div>
                            <div>
                                <span className="me-1">{language(userData?.tehsilDisplayCode)},</span>
                                <span className="me-1">{language(userData?.districtDisplayCode)},</span>
                            </div>
                            <div>
                                <span className="me-1">{language(userData?.stateDisplayCode)},</span>
                                <span>{userData?.pincode}</span>
                            </div>
                        </div>
                    </div>

                    {showNeedLoanOption && <div className='card mt-3'>
                        <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center">
                                <div className="flex-fill">
                                    <div className="fw-bold">{language("label.need_loan_for_category_name")?.replace("{category_name}", language(item?.categoryMap?.[item?.categoryId]?.displayCode) || "")}</div>
                                    <div className="fs-7 text-body-secondary">{language("label.apply_to_get_the_best_offers")}</div>
                                    <div className="mt-3">
                                        <Button primary solid rounded small onClick={handleNeedLoanApplyNow}>
                                            <span>{language("label.apply_now")}</span>
                                            <i className="bi bi-arrow-right ms-2"></i>
                                        </Button>
                                    </div>
                                </div>
                                <div>
                                    {/* image goes here for banner */}
                                </div>
                            </div>
                        </div>
                    </div>}

                    <div className="card mt-3">
                        <div className="card-body p-1">
                            <iframe
                                title="Preview Listing"
                                src={`https://maps.google.com/maps?q=${language(userData?.stateDisplayCode) + language(userData?.districtDisplayCode) + language(userData?.tehsilDisplayCode) + language(userData?.pincode)}&output=embed`}
                                width="100%"
                                height="250"
                                style={{ border: 0 }}
                                allowFullScreen=""
                                loading="lazy"
                            ></iframe>
                        </div>
                    </div>
                </div>
            </div>
            {toggleLoanDetailsPopup && <DialogBox width={600} title={"Loan enquiry details"} onClose={() => setToggleLoanDetailsPopup(false)}>
                <form onSubmit={handleSubmitLoanInterestedDetails} className='d-flex flex-column gap-3'>
                    <div>
                        <label className="form-label fs-7 kg-dark-gray" htmlFor="name">{language("label.name_as_per_pan")}<small className="kg-danger">*</small></label>
                        <input type="text" className='form-control form-control-sm' name="name" id="name" value={loanInterestedFormData?.name} onChange={handleInputChange} />
                        {renderError(errors, "name")}
                    </div>
                    <div>
                        <label className="form-label fs-7 kg-dark-gray" htmlFor="email">{language("label.email_optional")}</label>
                        <input type="email" className='form-control form-control-sm' name="email" id="email" value={loanInterestedFormData?.email} onChange={handleInputChange} />
                        {renderError(errors, "email")}
                    </div>
                    <div>
                        <label className="form-label fs-7 kg-dark-gray" htmlFor="loan-amount">{language("label.loan_amount")}<small className="kg-danger">*</small></label>
                        <input type="number" min="1" className='form-control form-control-sm' name="loan_amount" id="loan-amount" value={loanInterestedFormData?.loan_amount} onChange={handleInputChange} />
                        {renderError(errors, "loan_amount")}
                    </div>
                    <div>
                        <p>{language("label.do_you_have_a_property_for_loan")}</p>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="have_property_for_loan" id="have-property-for-loan-no-yes" value="Yes" onChange={handleInputChange} checked={loanInterestedFormData?.have_property_for_loan === 'Yes'} />
                            <label className="form-check-label" htmlFor="have-property-for-loan-yes">{language("label.yes")}</label>
                        </div>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="have_property_for_loan" id="have-property-for-loan-no" value="No" onChange={handleInputChange} checked={loanInterestedFormData?.have_property_for_loan === 'No'} />
                            <label className="form-check-label" htmlFor="have-property-for-loan-no">{language("label.no")}</label>
                        </div>
                    </div>
                    <div>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="checkbox" id="agree-terms" name="agree_terms_conditions" onChange={(e) => { e.target.value = e.target.checked; handleInputChange(e) }} />
                            <label className="form-check-label" htmlFor="agree-terms">{language("label.loan_term_and_condition")}</label>
                            {renderError(errors, "agree_terms_conditions")}
                        </div>
                    </div>
                    <div className='text-end mt-3'>
                        <Button type='submit' primary solid rounded>{language("label.submit")}</Button>
                    </div>
                </form>
            </DialogBox>}
            {showSharePopup && <SharePopup subject='Listing details' content={shareContent} onClose={handleSharePopupClose} />}
        </MainAdsLayout>
    )
}

export default UserProfileDetail